import React from "react";
import { debugInfo } from "../../utils/session";

const debug = debugInfo;

type DebugModalProps = {
  closeDebugModal: VoidFunction;
};

const DebugModal = ({ closeDebugModal }: DebugModalProps) => {
  return (
    <>
      <div className="modal fade d-block" tabIndex={-1} role="dialog">
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ transform: "translate(0, 0)" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={closeDebugModal}
              >
                <span aria-hidden="true">×</span>
              </button>
              <h5 className="modal-title" id="exampleModalCenterTitle">
                Debug
              </h5>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "500px", overflow: "scroll" }}
            >
              {debug && (
                <div className="row">
                  {debug.info &&
                    debug.info.map((item, index) => {
                      return (
                        <div className="col-12">
                          <b>{item.label}</b>: {item.value}
                        </div>
                      );
                    })}
                  {debug.timers && (
                    <div className="col-12">
                      <h1>Timers</h1>
                      {debug.timers.map((item, index) => {
                        return (
                          <div className="row">
                            <div className="col-12">
                              <b>{item.label}</b>: {item.value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {debug.debug_items && (
                    <div className="col-12">
                      <h1>Debug Items</h1>
                      {debug.debug_items.map((item, index) => {
                        return (
                          <div className="row" key={index}>
                            <div className="col-12">
                              <b>{item.label}</b>: {item.value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {debug.user && (
                    <div className="col-12">
                      <h1>User</h1>
                      <pre>{JSON.stringify(debug.user)}</pre>
                    </div>
                  )}

                  {debug.client && (
                    <div className="col-12">
                      <h1>Client</h1>
                      <pre>{JSON.stringify(debug.client)}</pre>
                    </div>
                  )}

                  {debug.server && (
                    <div className="col-12">
                      <h1>Server</h1>
                      <pre>{JSON.stringify(debug.server)}</pre>
                    </div>
                  )}

                  {debug.queries && (
                    <div className="col-12">
                      <h1>Queries</h1>
                      {debug.queries.map((item, index) => {
                        return (
                          <div className="row" key={index}>
                            <div className="col-12">
                              <b>{item.label}</b>: {item.value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                data-dismiss="modal"
                onClick={closeDebugModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade" onClick={closeDebugModal}></div>
    </>
  );
};

export default DebugModal;
